export default __webpack_public_path__ + "static/media/credit-card.38c04cd7.svg";